type SectionStatus = {
  "Basic Details": boolean;
  Education: boolean;
  Experience: boolean;
};

let globalSectionStatus: SectionStatus = {
  "Basic Details": false,
  Education: false,
  Experience: false,
};

let listeners: ((status: SectionStatus) => void)[] = [];
let isInitialized = false;

export const talentProfileStore = {
  getStatus: () => globalSectionStatus,

  setStatus: (status: Partial<SectionStatus>) => {
    globalSectionStatus = { ...globalSectionStatus, ...status };
    listeners.forEach((listener) => listener(globalSectionStatus));
  },

  subscribe: (listener: (status: SectionStatus) => void) => {
    listeners.push(listener);
    return () => {
      listeners = listeners.filter((l) => l !== listener);
    };
  },

  initialize: async (fetchStatusFn: () => Promise<SectionStatus>) => {
    if (isInitialized) return;

    try {
      const status = await fetchStatusFn();
      talentProfileStore.setStatus(status);
      isInitialized = true;
    } catch (error) {
      console.error("Failed to initialize profile store:", error);
    }
  },

  isInitialized: () => isInitialized,

  reset: () => {
    globalSectionStatus = {
      "Basic Details": false,
      Education: false,
      Experience: false,
    };
    listeners = [];
    isInitialized = false;
  },
};
